import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import hexToRgba from 'hex-to-rgba';
import styled from '@emotion/styled';
import { Image } from 'react-bootstrap';
import React, { useRef, useLayoutEffect } from 'react';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import colours from '~/utils/colours';
import useEventListener from '~/react-hooks/use-event-listener';
import { createFontAwesomeIcon } from '~/App/Components/Attributes/util';

const SelectedIcon = createFontAwesomeIcon(faCheck);

const PersonContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 0.25em 0;
  user-select: none;
  align-items: center;
  color: ${colours.greyDark};
  border-bottom: 1px solid ${colours.greyMedium};
  cursor: pointer;

  &:hover,
  &:focus {
    outline: none;
    background-color: ${hexToRgba(colours.blue, 0.1)};
  }
`;

const PersonName = styled.div`
  margin-left: 0.5em;
`;

const PersonSelected = styled.div`
  width: 30px;
  height: 30px;
  color: ${colours.greyMediumDark};
  display: flex;
  align-items: center;
  justify-content: center;
`;

function Person({ name, email, image, onClick, selected, focused }) {
  const ref = useRef();

  const handleKeyEvent = debounce((evt) => {
    switch (evt.code) {
      case 'Enter':
        evt.stopPropagation();
        evt.preventDefault();
        ref.current.click();
        break;
    }
  }, 100);

  useEventListener('keydown', handleKeyEvent, ref);

  useLayoutEffect(() => {
    if (focused) {
      ref.current.focus();
    }
  }, [focused]);

  return (
    <PersonContainer ref={ref} onClick={onClick} tabIndex={-1}>
      <PersonSelected>{selected && <SelectedIcon />}</PersonSelected>
      <Image width={30} height={30} circle src={image} />
      <PersonName>
        {name} {`<${email}>`}
      </PersonName>
    </PersonContainer>
  );
}

Person.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  focused: PropTypes.bool,
};

export default Person;
